import { ApplicationConfig } from "@angular/core";
import { provideRouter } from "@angular/router";

import { routes } from "./app.routes";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
} from "@angular/common/http";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideCharts, withDefaultRegisterables } from "ng2-charts";
import { jwtInterceptor } from "./jwt.interceptor";
import {
  LUCIDE_ICONS,
  LucideIconProvider,
  CircleDot,
  User,
  Lock,
  AlertTriangle,
  Mail,
  Eye,
  EyeOff,
  Sparkles,
  Hand,
  BarChart3,
  Trophy,
  Star,
  Bell,
  Target,
  Smartphone,
  MessageCircle,
  Medal,
  Calendar,
  Clock,
  Timer,
  MapPin,
  Landmark,
  Search,
  UserPlus,
  Share2,
  Copy,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  Plus,
  Minus,
  X,
  Check,
  Info,
  Settings,
  LogOut,
  Edit,
  Trash2,
  Send,
  Users,
  Home,
  Swords,
  TrendingUp,
  Filter,
  ArrowLeft,
  ArrowRight,
  Hash,
  CircleCheck,
  CircleX,
  Loader2,
  QrCode,
  Link,
  Phone,
  ShieldCheck,
  Save,
  ToggleLeft,
  ToggleRight,
  Crown,
  Award,
  Sun,
  Image,
} from "lucide-angular";

const icons = {
  CircleDot,
  User,
  Lock,
  AlertTriangle,
  Mail,
  Eye,
  EyeOff,
  Sparkles,
  Hand,
  BarChart3,
  Trophy,
  Star,
  Bell,
  Target,
  Smartphone,
  MessageCircle,
  Medal,
  Calendar,
  Clock,
  Timer,
  MapPin,
  Landmark,
  Search,
  UserPlus,
  Share2,
  Copy,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  Plus,
  Minus,
  X,
  Check,
  Info,
  Settings,
  LogOut,
  Edit,
  Trash2,
  Send,
  Users,
  Home,
  Swords,
  TrendingUp,
  Filter,
  ArrowLeft,
  ArrowRight,
  Hash,
  CircleCheck,
  CircleX,
  Loader2,
  QrCode,
  Link,
  Phone,
  ShieldCheck,
  Save,
  ToggleLeft,
  ToggleRight,
  Crown,
  Award,
  Sun,
  Image,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideCharts(withDefaultRegisterables()),
    provideHttpClient(withInterceptors([jwtInterceptor])),
    {
      provide: LUCIDE_ICONS,
      multi: true,
      useValue: new LucideIconProvider(icons),
    },
  ],
};
